import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../../ns_libs/nsAxios';
import API_ENDPOINTS, { QUERY_KEYS } from '../../../services/urls';
import { trackDatadogRumError } from '../../../utils/initDatadogRum';
import { ISubprojectStage } from '../types';

export const getSubprojectsStages = async () => {
    const response = await axiosInstance.get(API_ENDPOINTS.SUBPROJECT_STAGES);
    if (!Array.isArray(response.data)) {
        trackDatadogRumError(
            new Error('[useGetSubprojectsStages] Expected array response'),
            { receivedType: typeof response.data, receivedValue: response.data },
        );
        return [];
    }
    return response.data;
};

export const useGetSubprojectsStages = () => useQuery<ISubprojectStage[], Error>({
    queryKey: [QUERY_KEYS.SUBPROJECT_STAGES],
    queryFn: async () => getSubprojectsStages(),
    staleTime: Infinity,
});
